import { AxiosResponse } from 'axios';
import { LoginRequestType, LoginResponseType } from './types';
import * as api from '../api';

export const login = (
  payload: LoginRequestType,
): Promise<AxiosResponse<LoginResponseType>> =>
  api.post('/auth/login', payload);
